import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  showOrganizationName = signal(false);
  hideHeader = new BehaviorSubject(false);

  backUrl$: BehaviorSubject<string | null | boolean> = new BehaviorSubject<string | null | boolean>(
    null,
  );

  hasBack = signal(false);
}
